import Types from "./Types";

export const getWhatsappTemplatesRequest = () => ({
  type: Types.GET_WHATSAPP_TEMPLATES_REQUEST,
});

export const getWhatsappTemplatesSuccess = (data) => ({
  type: Types.GET_WHATSAPP_TEMPLATES_SUCCESS,
  payload: data,
});

export const getWhatsappTemplatesFail = (error) => ({
  type: Types.GET_WHATSAPP_TEMPLATES_FAIL,
  payload: error,
});

export const getWhatsappTemplateRequest = (name) => ({
  type: Types.GET_WHATSAPP_TEMPLATE_REQUEST,
  payload: name,
});

export const getWhatsappTemplateSuccess = (data) => ({
  type: Types.GET_WHATSAPP_TEMPLATE_SUCCESS,
  payload: data,
});

export const getWhatsappTemplateFail = (error) => ({
  type: Types.GET_WHATSAPP_TEMPLATE_FAIL,
  payload: error,
});

export const selectWhatsappTemplate = (template) => ({
  type: Types.SELECT_WHATSAPP_TEMPLATE,
  payload: template,
});

export const whatsappTemplateDraftChange = (partial) => ({
  type: Types.WHATSAPP_TEMPLATE_DRAFT_CHANGE,
  payload: partial,
});

export const whatsappTemplateResetDraft = () => ({
  type: Types.WHATSAPP_TEMPLATE_RESET_DRAFT,
});

export const saveWhatsappTemplateRequest = (name, body, action) => ({
  type: Types.SAVE_WHATSAPP_TEMPLATE_REQUEST,
  payload: { name, body },
  action,
});

export const saveWhatsappTemplateSuccess = (data) => ({
  type: Types.SAVE_WHATSAPP_TEMPLATE_SUCCESS,
  payload: data,
});

export const saveWhatsappTemplateFail = (error, validationErrors) => ({
  type: Types.SAVE_WHATSAPP_TEMPLATE_FAIL,
  payload: { error, validationErrors },
});

export const setWhatsappTemplatesLoading = (isLoading) => ({
  type: Types.WHATSAPP_TEMPLATES_LOADING,
  payload: isLoading,
});

export const setWhatsappTemplateSaving = (isSaving) => ({
  type: Types.WHATSAPP_TEMPLATE_SAVING,
  payload: isSaving,
});
